import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import ColorComponent from "./SvgColorOverview";
import ResingBenefitTextComponent from "./ResingBenefitTextComponent";
import * as message from "../MessageConstant";
import Health from "./SizingHealthAnalysisTable";
import Recommend from "./ResizeRecommendationTable";
import GaiRecommend from "./ResizeGaiRecommendationTable";
import Resize from "./ResizeBenefitTable";
import GaiResize from "./ResizeGaiBenefitTable";

import CostHealthModal from "./CostHealthDetails";
import SummaryStatus from "./RecommendationSummary";
import Recommendstatus from "./RecommendationStatus";
import ValidationSummary from "./ValidationSummary";
import ValidationTable from "./ValidationTable";
import ValidationDetailsTable from "./ValidationDetailsTable";
import Logo from "./Logo";
import {
  getStringDate,
  getStringDateAnalysis,
} from "../../../Constants/CommonConstant";
import "../../SinginComponent/style.css";
import ProviderUtils from "../../CommonComponent/ProviderUtils";

class EntityTypeSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      analysisStatus: this.props.data,
      viewResultData: [],
      modalLoader: false,
      resultData: this.props.data,
      aggIconData: [],
      balIconData: [],
      healthyIconData: [],
      gaiIconData: [],
      atb: "1",
      acol: "",
      modal: false,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: true,
      vmName: this.props.data.Name,
      aggrIcondataStatus: [],
      balIcondataStatus: [],
      healthyIcondataStatus: [],
      isAsp:
        this.props.isAsp !== null && this.props.isAsp !== undefined
          ? this.props.isAsp
          : false,
      entityType:
        this.props.entityType !== null && this.props.entityType !== undefined
          ? this.props.entityType
          : "vm",
      analysisCnt: this.props.analysisCnt,
      enhancedCostRatio: this.props.enhancedCostRatio,
      economicalPerfRatio: this.props.economicalPerfRatio,
      providerName: this.props.providerName,
    };
  }

  componentWillMount() {
    var aggrIcondata = [];
    var balIcondata = [];
    var healthyIcondata = [];
    var gaiIcondata = [];
    var gaicpu = [];
    var gainetwork = [];
    var gaimemory = [];
    var gaidisks = [];

    const analysisGoalTypes = [
      { label: "Economical", key: "aggressive" },
      { label: "Balanced", key: "balanced" },
      { label: "Enhanced", key: "conservative" },
    ];

    for (const analysisType of analysisGoalTypes) {
      const analysisIconData = this.state.resultData[analysisType.key];
      const groupedIconData = [];
      const choiceObjNew = { recommendationChoiceNum: "" };

      analysisIconData.vm.map((key) => {
        const choice = key.recommendationChoiceNum ?? 0;

        if (!choiceObjNew[choice]) {
          choiceObjNew[choice] = {
            recommendationChoiceNum: choice,
            cpu: [],
            memory: [],
            network: [],
            disks: [],
            gpu: [],
            gpumemory: [],
          };
          groupedIconData.push(choiceObjNew[choice]);
        }
      });

      analysisIconData.vm.map((key) => {
        const choice = key.recommendationChoiceNum ?? 0;

        groupedIconData[choice].cpu.push({
          costColor: key.current_vcpu_cost,
          healthColor: key.current_vcpu_health,
          icon: "cpu",
          resize: key.vcpuResizeImage,
          status: key.recommendedVMStatus,
          recommendationsIconColor: {
            costColor: key.recommended_cpu_util,
            healthColor: key.recommended_cpu_health,
          },
        });
        groupedIconData[choice].memory.push({
          costColor: key.current_memory_cost,
          healthColor: key.current_memory_health,
          icon: "memory",
          resize: key.memoryResizeImage,
          status: key.recommendedVMStatus,
          recommendationsIconColor: {
            costColor: key.recommended_mem_util,
            healthColor: key.recommended_mem_health,
          },
        });
        groupedIconData[choice].network.push({
          costColor: key.current_network_cost,
          healthColor: key.current_network_health,
          icon: "network",
          resize: key.networkResizeImage,
          status: key.recommendedVMStatus,
          recommendationsIconColor: {
            costColor: key.recommended_net_util,
            healthColor: key.recommended_net_health,
          },
        });
      });

      analysisIconData.osdisk.map((key) => {
        const choice = key.recommendationChoiceNum ?? 0;

        groupedIconData[choice].disks.push({
          costColor: key.current_os_disk_cost,
          healthColor: key.current_os_disk_health,
          icon: "osdisk",
          resize: key.osDiskResizeImage,
          status: key.recommendedOSDiskStatus,
          recommendationsIconColor: {
            costColor: key.recommended_osdisk_util,
            healthColor: key.recommended_osdisk_health,
          },
        });
      });

      Object.keys(analysisIconData.dataDisk || {}).length > 0 &&
        Object.keys(analysisIconData.dataDisk).map((key) => {
          return analysisIconData.dataDisk[key].map((value) => {
            const choice = value.recommendationChoiceNum ?? 0;

            groupedIconData[choice].disks.push({
              costColor: value.current_data_disk_cost,
              healthColor: value.current_data_disk_health,
              icon: "datadisk",
              resize: value.diskResizeImage,
              status: value.recommendedDataDiskStatus,
              recommendationsIconColor: {
                costColor: value.recommended_datadisk_util,
                healthColor: value.recommended_datadisk_health,
              },
            });
          });
        });

      analysisIconData.gpuDTO.map((key) => {
        const choice = key.recommendationChoiceNum ?? 0;

        if (key.currentGpuNum) {
          groupedIconData[choice].gpu.push({
            costColor: key.gpuUtilization_cost,
            healthColor: key.gpu_sm_health,
            icon: "gpu",
            resize: "",
            status: null,
            recommendationsIconColor: {
              costColor: key.recommended_gpuproc_util,
              healthColor: key.recommended_gpuproc_health,
            },
          });

          groupedIconData[choice].gpumemory.push({
            costColor: key.gpuMemUsed_cost,
            healthColor: key.gpu_mem_health,
            icon: "gpumemory",
            resize: "",
            status: null,
            recommendationsIconColor: {
              costColor: key.recommended_gpumem_util,
              healthColor: key.recommended_gpumem_health,
            },
          });
        }
      });

      if (analysisType.label === "Economical") {
        aggrIcondata = groupedIconData;

        this.setState({
          aggIconData: aggrIcondata,
          aggrIcondataStatus: aggrIcondata,
        });
      }

      if (analysisType.label === "Balanced") {
        balIcondata = groupedIconData;
        this.setState({
          balIconData: balIcondata,
          balIcondataStatus: balIcondata,
        });
      }

      if (analysisType.label === "Enhanced") {
        healthyIcondata = groupedIconData;
        this.setState({
          healthyIconData: healthyIcondata,
          healthyIcondataStatus: healthyIcondata,
        });
      }
    }
    this.state.resultData.gaiValidationData &&
      this.state.resultData.gaiValidationData.vm.map((key) => {
        gaicpu.push({
          costColor: key.current_vcpu_cost,
          healthColor: key.current_vcpu_health,
          icon: "cpu",
          resize: key.vcpuResizeImage,
          status: key.recommendedVMStatus,
        });
        gaimemory.push({
          costColor: key.current_memory_cost,
          healthColor: key.current_memory_health,
          icon: "memory",
          resize: key.memoryResizeImage,
          status: key.recommendedVMStatus,
        });
        gainetwork.push({
          costColor: key.current_network_cost,
          healthColor: key.current_network_health,
          icon: "network",
          resize: key.networkResizeImage,
          status: key.recommendedVMStatus,
        });
      });
    this.state.resultData.gaiValidationData &&
      this.state.resultData.gaiValidationData.osdisk.map((key) => {
        gaidisks.push({
          costColor: key.current_os_disk_cost,
          healthColor: key.current_os_disk_health,
          icon: "osdisk",
          resize: key.osDiskResizeImage,
          status: key.recommendedOSDiskStatus,
        });
      });
    this.state.resultData.gaiValidationData &&
      Object.keys(this.state.resultData.gaiValidationData.dataDisk).map(
        (key) => {
          return this.state.resultData.gaiValidationData.dataDisk[key].map(
            (value) => {
              gaidisks.push({
                costColor: value.current_data_disk_cost,
                healthColor: value.current_data_disk_health,
                icon: "datadisk",
                resize: value.diskResizeImage,
                status: value.recommendedDataDiskStatus,
              });
            }
          );
        }
      );
    gaiIcondata.push({
      cpu: gaicpu,
      memory: gaimemory,
      network: gainetwork,
      disks: gaidisks,
    });
    this.setState({ gaiIconData: gaiIcondata });

    this.setState({ modalLoader: false });
  }
  render() {
    let bvmStatus = this.state.resultData.bvmState;
    let VmData = this.state.resultData.aggressive.vm.map((key) => {
      return this.state.entityType !== "db" ? (
        this.state.entityType === "asp" ? (
          <div
            style={{
              width: "100%",
              dispaly: "flex",
              justifyContent: "center",
              paddingTop: "5px",
            }}
          >
            <div className="InfoDiv">
              <div
                className="divText"
                style={{ fontSize: "18px", width: "90%" }}
              >
                {this.state.resultData.VMInfo}
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              dispaly: "flex",
              justifyContent: "center",
              paddingTop: "5px",
            }}
          >
            <div className="InfoDiv">
              <div
                className="divText"
                style={{ fontSize: "18px", width: "90%" }}
              >
                {this.state.resultData.VMInfo}
              </div>
            </div>
          </div>
        )
      ) : (
        <div
          style={{
            width: "100%",
            dispaly: "flex",
            justifyContent: "center",
            paddingTop: "5px",
          }}
        >
          <div className="InfoDiv">
            <div className="divText" style={{ fontSize: "18px", width: "90%" }}>
              {this.state.resultData.VMInfo}
            </div>
          </div>
        </div>
      );
    });
    let vmOverviewInfoDiv = (
      <div id="rowOverviewDetail">
        <div style={{ padding: "0px" }}>
          {VmData}
          <div className="InfoDiv">
            <div className="divText" style={{ fontSize: "18px", width: "90%" }}>
              <div>
                {this.state.resultData &&
                this.state.resultData.analysisDatetimestamp
                  ? `Analyzed: ${getStringDateAnalysis(
                      this.state.resultData.analysisDatetimestamp,
                      this.props.userGmtId,
                      this.props.userTimeZone
                    )}`
                  : null}
                {this.state.resultData &&
                (this.state.resultData.bvmState === "ANALYZED" ||
                  this.state.resultData.bvmState === "VERIFIED" ||
                  this.state.resultData.bvmState === "OPTIMIZED")
                  ? this.state.resultData.metricDataDurationUsed !== null
                    ? `, ${this.state.resultData.metricDataDurationUsed}`
                    : null
                  : null}
              </div>
            </div>
          </div>
          {this.state.resultData.isResourceChanged !== undefined ? (
            <div className="InfoDiv" style={{ backgroundColor: "#ffffff" }}>
              {this.state.resultData.isResourceChanged === true ? (
                <div style={{ color: "#e32227", width: "80%" }}>
                  {" "}
                  {bvmStatus === "VALIDATED" ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          message.VMResourceChngedFlagInfoTextSummaryValidated +
                          " " +
                          this.state.resultData.resourceChangeDetails,
                      }}
                    />
                  ) : (
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          message.VMResourceChngedFlagInfoTextSummaryAnalyzed +
                          " " +
                          this.state.resultData.resourceChangeDetails,
                      }}
                    />
                  )}{" "}
                </div>
              ) : null}
            </div>
          ) : null}
          {this.state.resultData.priceChangeMsg !== undefined &&
          this.state.resultData.priceChangeMsg !== null ? (
            <div
              className="InfoDiv"
              style={{ backgroundColor: "#ffffff", marginBottom: "5px" }}
            >
              <div style={{ color: "#e32227", width: "80%" }}>
                {this.state.resultData.priceChangeMsg}{" "}
              </div>
            </div>
          ) : null}
          {/*(this.state.resultData.metricDataAvalability !== undefined && this.state.resultData.metricDataAvalability !== null && this.state.resultData.metricDataAvalability.trim() !== "") ?
                                            <div className="InfoDiv" style={{backgroundColor:"#ffffff", marginBottom:"5px" , borderRadius:"7px"}}>
                                                <div style={{color:"black", width:"80%"}}><div>Note : {this.state.resultData.metricDataAvalability}</div></div>
                                            </div> : null
                                            */}
        </div>
      </div>
    );
    let ecomonicalAnchor = "#" + this.state.vmName + "Aggressive";
    let balancedAnchor = "#" + this.state.vmName + "Balanced";
    let conservativeAnchor = "#" + this.state.vmName + "Conservative";
    let economicalId = this.state.vmName + "Aggressive";
    let balancedId = this.state.vmName + "Balanced";
    let conservativeId = this.state.vmName + "Conservative";
    let forValidation =
      this.state.resultData.validationData !== null &&
      this.state.resultData.validationData !== undefined;
    let hostOnly =
      this.state.resultData !== undefined &&
      this.state.resultData.aggressive !== undefined &&
      ProviderUtils.hostOnly(
        this.state.providerName,
        this.state.resultData.aggressive.metricsPlatform
      );

    if (
      forValidation === true &&
      (bvmStatus === "VALIDATED" ||
        bvmStatus === "OPTIMALLY SIZED" ||
        bvmStatus === "CUSTOM-SIZED" ||
        bvmStatus === "OPTIMALLY SIZED" ||
        bvmStatus === "OPTIMIZING")
    ) {
      bvmStatus = "VALIDATED";
    }

    let isResizingDone =
      this.state.resultData.aggressive.isRecommendationSelected === true ||
      this.state.resultData.balanced.isRecommendationSelected === true ||
      this.state.resultData.conservative.isRecommendationSelected === true;
    let needPageBreakForBenefitText = true; //always break page
    if (
      this.state.resultData.aggressive.summary.costSummaryText !== null &&
      this.state.resultData.aggressive.summary.perfSummaryText !== null
    ) {
      if (
        this.state.resultData.aggressive.summary.costSummaryDescription.length >
          0 ||
        this.state.resultData.aggressive.summary.perfSummaryDescription.length >
          0
      ) {
        needPageBreakForBenefitText = true;
      }
    } else if (
      this.state.resultData.balanced.summary.costSummaryText !== null &&
      this.state.resultData.balanced.summary.perfSummaryText !== null
    ) {
      if (
        this.state.resultData.balanced.summary.costSummaryDescription.length >
          0 ||
        this.state.resultData.balanced.summary.perfSummaryDescription.length > 0
      ) {
        needPageBreakForBenefitText = true;
      }
    } else if (
      this.state.resultData.conservative.summary.costSummaryText !== null &&
      this.state.resultData.conservative.summary.perfSummaryText !== null
    ) {
      if (
        this.state.resultData.conservative.summary.costSummaryDescription
          .length > 0 ||
        this.state.resultData.conservative.summary.perfSummaryDescription
          .length > 0
      ) {
        needPageBreakForBenefitText = true;
      }
    }

    let aggValidatedResized =
      forValidation &&
      this.state.resultData.validationData.perfType === "Aggressive" &&
      this.state.resultData.aggressive.isRecommendationSelected === true;
    let balValidatedResized =
      forValidation &&
      this.state.resultData.validationData.perfType === "Balanced" &&
      this.state.resultData.balanced.isRecommendationSelected === true;
    let conValidatedResized =
      forValidation &&
      this.state.resultData.validationData.perfType === "Conservative" &&
      this.state.resultData.conservative.isRecommendationSelected === true;
    let resizedObjective =
      this.state.resultData.aggressive.isRecommendationSelected === true
        ? "Economical "
        : this.state.resultData.balanced.isRecommendationSelected === true
        ? "Balanced "
        : this.state.resultData.conservative.isRecommendationSelected === true
        ? "Enhanced "
        : " ";
    let resizingHeadingLine1 = "Resizing per Selected Recommendation";
    let resizingHeading = "Resizing per Selected Recommendation";
    if (
      aggValidatedResized === true ||
      balValidatedResized === true ||
      conValidatedResized === true
    ) {
      resizingHeading = "Resizing of Validated Recommendation";
      resizingHeadingLine1 = "Resizing of Validated Recommendation";
    }

    let analysisHeading = "Rightsizing Analysis";
    let recommendationHeadingLine1 = "Recommendation";
    let expBenDrawHeadingLine1 = "Expected Benefits & Drawbacks";
    let validationHeadingLine1 = "Recommendation Validation";
    let valBenDrawHeadingLine1 = "Validated Benefits & Drawbacks";
    let valSimPlotHeadingLine1 =
      " Simulation Confidence and Plots for Validation of";
    let platform =
      this.state.resultData !== undefined &&
      this.state.resultData.metricsPlatform === "Host"
        ? " (Only Host Metrics Used)"
        : "";
    return (
      <div>
        <div
          className="container-verf container-verf-padding"
          role="main"
          style={{ width: "60%", margin: "auto", marginTop: "300px" }}
        >
          <>
            <div className="Sub-Heading">Rightsizing Analysis</div>
            <div
              className="sum-cont"
              id={`optimizationAnalysis${this.state.analysisCnt}`}
            >
              <div className="sum-item">
                <div className="sum-inner-item">
                  {this.state.aggIconData[0] !== undefined &&
                  this.state.aggIconData[0].gpu !== undefined &&
                  this.state.aggIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.aggIconData[0].gpu}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.aggIconData[0].gpumemory}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].cpu}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.aggIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.aggIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].memory}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].network}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.aggIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.aggIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
              <div className="sum-item" id="modTwo">
                <div className="sum-inner-item">
                  {this.state.balIconData[0] !== undefined &&
                  this.state.balIconData[0].gpu !== undefined &&
                  this.state.balIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.balIconData[0].gpu}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.balIconData[0].gpumemory}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].cpu}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.balIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.balIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].memory}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].network}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.balIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.balIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
              <div className="sum-item">
                <div className="sum-inner-item">
                  {this.state.healthyIconData[0] !== undefined &&
                  this.state.healthyIconData[0].gpu !== undefined &&
                  this.state.healthyIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.healthyIconData[0].gpu}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.healthyIconData[0].gpumemory}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                          />
                        </div>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].cpu}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.healthyIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.healthyIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].memory}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].network}
                          isResize={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.healthyIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.healthyIconData[0].disks}
                            isResize={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="Sub-Heading">Rightsizing Recommendations</div>
            <div
              className="sum-cont"
              id={`optimizationRecommendations${this.state.analysisCnt}`}
            >
              <div className="sum-item">
                <div className="sum-inner-item">
                  {this.state.aggIconData[0] !== undefined &&
                  this.state.aggIconData[0].gpu !== undefined &&
                  this.state.aggIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.aggIconData[0].gpu}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>

                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.aggIconData[0].gpumemory}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].cpu}
                          isResize={true}
                          isLine={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.aggIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.aggIconData[0].disks}
                            isResize={true}
                            isLine={false}
                            showInfo={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].memory}
                          isResize={true}
                          isLine={false}
                          showInfo={false}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.aggIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.aggIconData[0].network}
                          isResize={true}
                          isLine={false}
                          showInfo={false}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.aggIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.aggIconData[0].disks}
                            isResize={true}
                            isLine={false}
                            showInfo={false}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            isResizeFirstPage={
                              this.state.aggIconData[0].disks.length >= "7"
                                ? true
                                : false
                            }
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
              <div className="sum-item" id="modTwo">
                <div className="sum-inner-item">
                  {this.state.balIconData[0] !== undefined &&
                  this.state.balIconData[0].gpu !== undefined &&
                  this.state.balIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.balIconData[0].gpu}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.balIconData[0].gpumemory}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>
                    </>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].cpu}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.balIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.balIconData[0].disks}
                            isResize={true}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].memory}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.balIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.balIconData[0].network}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.balIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.balIconData[0].disks}
                            isResize={true}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            isResizeFirstPage={
                              this.state.balIconData[0].disks.length >= "7"
                                ? true
                                : false
                            }
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
              <div className="sum-item">
                <div className="sum-inner-item">
                  {this.state.healthyIconData[0] !== undefined &&
                  this.state.healthyIconData[0].gpu !== undefined &&
                  this.state.healthyIconData[0].gpu.length > 0 ? (
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.healthyIconData[0].gpu}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          <ColorComponent
                            data={this.state.healthyIconData[0].gpumemory}
                            isResize={true}
                            isLine={false}
                            isAsp={this.state.isAsp}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        </div>
                      </Row>
                    </>
                  ) : null}

                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].cpu}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType === "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.healthyIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.healthyIconData[0].disks}
                            isResize={true}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].memory}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          hostOnly={hostOnly}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  <Row>
                    <div className="maindiv-summary">
                      {this.state.healthyIconData[0] !== undefined ? (
                        <ColorComponent
                          data={this.state.healthyIconData[0].network}
                          isResize={true}
                          isAsp={this.state.isAsp}
                          entityType={this.state.entityType}
                          showCostPerfMarker={true}
                          type="recommendation"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </Row>
                  {this.props.entityType !== "db" ? (
                    <Row>
                      <div className="maindiv-summary">
                        {this.state.healthyIconData[0] !== undefined ? (
                          <ColorComponent
                            data={this.state.healthyIconData[0].disks}
                            isResize={true}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                            showCostPerfMarker={true}
                            isResizeFirstPage={
                              this.state.healthyIconData[0].disks.length >= "7"
                                ? true
                                : false
                            }
                            type="recommendation"
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    </Row>
                  ) : null}
                </div>
              </div>
            </div>

            {/*Start Optimization GAI Recommendations */}

            {this.state.resultData.gaiValidationData ? (
              needPageBreakForBenefitText ? (
                <div style={{ pageBreakBefore: "always" }}>
                  <Row>
                    <Col>
                      <div className="InfoDiv">
                        <div className="divText" style={{ fontSize: "18px" }}>
                          {this.state.resultData.vminfo}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <div className="sum-header">
                    <div className="mod-tab">
                      <a href={ecomonicalAnchor}>
                        <b>
                          <u>
                            <h4>
                              Economical
                              <label
                                style={{ fontWeight: "300", fontSize: "16px" }}
                              >
                                (P90)
                              </label>
                            </h4>
                          </u>
                        </b>
                      </a>
                      <span>
                        <i>Cost Reducing</i>
                      </span>
                      <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                        {this.state.economicalPerfRatio === 0
                          ? `Lowest Cost regardless of Performance`
                          : `Lower Cost without going below ${this.state.economicalPerfRatio} x Current Performance`}
                      </div>
                    </div>
                    <div className="mod-tab" id="modTwo">
                      <a href={balancedAnchor}>
                        <b>
                          <u>
                            <h4>
                              Balanced
                              <label
                                style={{ fontWeight: "300", fontSize: "16px" }}
                              >
                                (P95)
                              </label>
                            </h4>
                          </u>
                        </b>
                      </a>
                      <span>
                        <i>Cost Reducing and Performance Improving</i>
                      </span>
                      <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                        Lower Cost for Same Performance
                      </div>
                    </div>
                    <div className="mod-tab">
                      <a href={conservativeAnchor}>
                        <b>
                          <u>
                            <h4>
                              Enhanced
                              <label
                                style={{ fontWeight: "300", fontSize: "16px" }}
                              >
                                (P99.5)
                              </label>
                            </h4>
                          </u>
                        </b>
                      </a>
                      <span>
                        <i>Performance Improving</i>
                      </span>
                      <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                        {this.state.enhancedCostRatio === 999999
                          ? `Highest Performance regardless of Cost`
                          : `Better Performance without exceeding ${this.state.enhancedCostRatio} x Current Cost`}
                      </div>
                    </div>
                  </div>
                  <div className="Sub-legend">
                    <Row>
                      <Col id="healthcolor">
                        <lable className="legend">
                          <b>Legend</b>
                        </lable>
                        <div className="legendLable">
                          <div className="legendclass Good">Good</div>
                          <div className="legendclass Fair">Fair</div>
                          <div className="legendclass Poor">Poor</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="Sub-Heading">
                    <label>Optimization GAI Recommendations</label>
                  </div>
                </div>
              ) : (
                <div className="Sub-Heading">
                  Optimization GAI Recommendations
                </div>
              )
            ) : null}
            {this.state.resultData.gaiValidationData ? (
              <div
                className="sum-cont"
                id={`optimizationGAIRecommendations${this.state.analysisCnt}`}
              >
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Aggressive" ? (
                    <div className="sum-inner-item">
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType === "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isLine={false}
                                showInfo={false}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType !== "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isLine={false}
                                showInfo={false}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                                isResizeFirstPage={
                                  this.state.gaiIconData[0].disks.length >= "7"
                                    ? true
                                    : false
                                }
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item" id="modTwo">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Balanced" ? (
                    <div className="sum-inner-item">
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType === "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType !== "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                                isResizeFirstPage={
                                  this.state.gaiIconData[0].disks.length >= "7"
                                    ? true
                                    : false
                                }
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Conservative" ? (
                    <div className="sum-inner-item">
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType === "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              entityType={this.state.entityType}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      {this.props.entityType !== "db" ? (
                        <Row>
                          <div className="maindiv-summary">
                            {this.state.gaiIconData[0] !== undefined ? (
                              <ColorComponent
                                data={this.state.gaiIconData[0].disks}
                                isResize={true}
                                isAsp={this.state.isAsp}
                                entityType={this.state.entityType}
                                showCostPerfMarker={true}
                                isResizeFirstPage={
                                  this.state.gaiIconData[0].disks.length >= "7"
                                    ? true
                                    : false
                                }
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            {/* End Optimization GAI Recommendations */}

            {/* <div className="Sub-Heading">Recommendation Actions</div>
            <div
              class="sum-cont"
              id={`recommended_Actions${this.state.analysisCnt}`}
            >
              <div class="sum-item">
                <div class="sum-inner-item">
                  <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                    <ul>
                      {this.state.resultData.aggressive?.recommendationActions.map(
                        (action, index) => (
                          <React.Fragment key={index}>
                            <li key={index}>{action}</li>
                          </React.Fragment>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div class="sum-item">
                <div class="sum-inner-item">
                  <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                    <ul>
                      {this.state.resultData.balanced?.recommendationActions.map(
                        (action, index) => (
                          <React.Fragment key={index}>
                            <li key={index}>{action}</li>
                          </React.Fragment>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <div class="sum-item">
                <div class="sum-inner-item">
                  <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                    <ul>
                      {this.state.resultData.conservative?.recommendationActions.map(
                        (action, index) => (
                          <React.Fragment key={index}>
                            <li key={index}>{action}</li>
                          </React.Fragment>
                        )
                      )}
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="Sub-Heading">
              Expected Benefits & Drawbacks of Recommendations
            </div>
            <div
              className="sum-cont"
              id={`expectedBenefits_DrawbacksOfRecommendations${this.state.analysisCnt}`}
            >
              <div className="sum-item">
                <div className="sum-inner-item">
                  <Row>
                    {this.state.resultData.aggressive?.summaryList &&
                      this.state.resultData.aggressive.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}

                    {this.state.resultData.aggressive?.summaryList &&
                      this.state.resultData.aggressive.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </Row>{" "}
                </div>
              </div>
              <div className="sum-item">
                <div className="sum-inner-item">
                  <Row>
                    {this.state.resultData.balanced?.summaryList &&
                      this.state.resultData.balanced.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}

                    {this.state.resultData.balanced?.summaryList &&
                      this.state.resultData.balanced.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </Row>{" "}
                </div>
              </div>
              <div className="sum-item">
                <div className="sum-inner-item">
                  <Row>
                    {this.state.resultData.conservative?.summaryList &&
                      this.state.resultData.conservative.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}

                    {this.state.resultData.conservative?.summaryList &&
                      this.state.resultData.conservative.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                    isAsp={this.state.isAsp}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </Row>
                </div>
              </div>
            </div>
          </>

          {/* Start Expected Benefits & Drawbacks of GAI Recommendations */}
          {this.state.resultData.gaiValidationData ? (
            <>
              <div className="Sub-Heading">
                Expected Benefits & Drawbacks of GAI Recommendations
              </div>

              <div
                className="sum-cont"
                id={`expectedBenefits_DrawbacksOfGAIRecommendations${this.state.analysisCnt}`}
              >
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Aggressive" ? (
                    <div className="sum-inner-item">
                      <Row>
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== null ? (
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryText
                              }
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryDescription
                              }
                              isAsp={this.state.isAsp}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== null ? (
                          <div className="maindiv-text-summary  maindiv-text-summary-grad">
                            {this.state.resultData.gaiValidationData !==
                            undefined ? (
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryText
                                }
                                isAsp={this.state.isAsp}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </Row>{" "}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Balanced" ? (
                    <div className="sum-inner-item">
                      <Row>
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== null ? (
                          <div className="maindiv-text-summary  maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryText
                              }
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryDescription
                              }
                              isAsp={this.state.isAsp}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== null ? (
                          <div className="maindiv-text-summary  maindiv-text-summary-grad">
                            {this.state.resultData.gaiValidationData !==
                            undefined ? (
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryText
                                }
                                isAsp={this.state.isAsp}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </Row>{" "}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Conservative" ? (
                    <div className="sum-inner-item">
                      <Row>
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .costSummaryText !== null ? (
                          <div className="maindiv-text-summary  maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryText
                              }
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryDescription
                              }
                              isAsp={this.state.isAsp}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                        {this.state.resultData.gaiValidationData !==
                          undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.gaiValidationData.summary
                          .perfSummaryText !== null ? (
                          <div className="maindiv-text-summary  maindiv-text-summary-grad">
                            {this.state.resultData.gaiValidationData !==
                            undefined ? (
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.gaiValidationData
                                    .summary.perfSummaryText
                                }
                                isAsp={this.state.isAsp}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}
                      </Row>
                    </div>
                  ) : null}
                </div>
              </div>
            </>
          ) : null}
          {/* End Expected Benefits & Drawbacks of GAI Recommendations */}

          {/* Start Gai Insight */}

          {["aggressive", "balanced", "conservative"].some((type) =>
            this.state.resultData?.[type]?.vm?.some(
              (item) =>
                item.recommendationChoiceNum === 0 &&
                item.gaiInsightSummary !== undefined &&
                item.gaiInsightSummary !== null
            )
          ) ? (
            <>
              <div className="Sub-Heading">AI Insight</div>

              <div
                className="sum-cont"
                id={`gaiInsight${this.state.analysisCnt}`}
              >
                <div className="sum-item">
                  <div className="sum-inner-item">
                    {this.state.resultData.aggressive?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={filteredItem?.gaiInsightSummary}
                              affectString={filteredItem?.gaiInsightDescription}
                            />
                          </div>
                        </Row>
                      ))}
                  </div>
                </div>
                <div className="sum-item">
                  <div className="sum-inner-item">
                    {this.state.resultData.balanced?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={filteredItem?.gaiInsightSummary}
                              affectString={filteredItem?.gaiInsightDescription}
                            />
                          </div>
                        </Row>
                      ))}
                  </div>
                </div>
                <div className="sum-item">
                  <div className="sum-inner-item">
                    {this.state.resultData.conservative?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={filteredItem?.gaiInsightSummary}
                              affectString={filteredItem?.gaiInsightDescription}
                            />
                          </div>
                        </Row>
                      ))}
                  </div>
                </div>
              </div>
            </>
          ) : null}
          {/* End Gai Insight */}

          <>
            {this.state.resultData.validationData !== null &&
            this.state.resultData.validationData !== undefined ? (
              <div>
                <div className="Sub-Heading">Recommendation Validation</div>
                <div
                  className="sum-cont"
                  id={`recommendationValidation${this.state.analysisCnt}`}
                >
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Aggressive"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Aggressive" ? (
                      <div className="sum-inner-item">
                        <Row>
                          <ValidationSummary
                            data={this.state.resultData.validationData}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Balanced"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Balanced" ? (
                      <div className="sum-inner-item">
                        <Row>
                          <ValidationSummary
                            data={this.state.resultData.validationData}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Conservative"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Conservative" ? (
                      <div className="sum-inner-item">
                        <Row>
                          <ValidationSummary
                            data={this.state.resultData.validationData}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {forValidation &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div className="Sub-Heading">
                  Validated Benefits & Drawbacks of Recommendation
                </div>
                <div
                  className="sum-cont"
                  id={`validatedBenefitsDrawbacksRecommendation${this.state.analysisCnt}`}
                >
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Aggressive"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Aggressive" ? (
                      <div className="sum-inner-item">
                        {this.state.resultData.aggressive !== undefined &&
                        this.state.resultData.aggressive.validation_summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.aggressive.validation_summary
                          .costSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                title={
                                  this.state.resultData.aggressive
                                    .validation_summary.costSummaryText
                                }
                                data={
                                  this.state.resultData.aggressive
                                    .validation_summary.costSummaryDescription
                                }
                                affectString={
                                  this.state.resultData.aggressive
                                    .validation_summary.perfAffected
                                }
                                valResult={
                                  this.state.resultData.aggressive
                                    .validation_summary.validation_cost_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Aggressive" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}

                        {this.state.resultData.aggressive !== undefined &&
                        this.state.resultData.aggressive.validation_summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.aggressive.validation_summary
                          .perfSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.aggressive
                                    .validation_summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.aggressive
                                    .validation_summary.perfSummaryText
                                }
                                affectString={
                                  this.state.resultData.aggressive.summary
                                    .increasedCost
                                }
                                valResult={
                                  this.state.resultData.aggressive
                                    .validation_summary.validation_perf_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Aggressive" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Balanced"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Balanced" ? (
                      <div className="sum-inner-item">
                        {this.state.resultData.balanced !== undefined &&
                        this.state.resultData.balanced.validation_summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.balanced.validation_summary
                          .costSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                title={
                                  this.state.resultData.balanced
                                    .validation_summary.costSummaryText
                                }
                                data={
                                  this.state.resultData.balanced
                                    .validation_summary.costSummaryDescription
                                }
                                affectString={
                                  this.state.resultData.balanced
                                    .validation_summary.perfAffected
                                }
                                valResult={
                                  this.state.resultData.balanced
                                    .validation_summary.validation_cost_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Balanced" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}

                        {this.state.resultData.balanced !== undefined &&
                        this.state.resultData.balanced.validation_summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.balanced.validation_summary
                          .perfSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.balanced
                                    .validation_summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.balanced
                                    .validation_summary.perfSummaryText
                                }
                                affectString={
                                  this.state.resultData.balanced
                                    .validation_summary.increasedCost
                                }
                                valResult={
                                  this.state.resultData.balanced
                                    .validation_summary.validation_perf_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Balanced" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="sum-item"
                    id={
                      this.state.resultData.validationData.perfType ===
                      "Conservative"
                        ? "modTwo"
                        : ""
                    }
                  >
                    {this.state.resultData.validationData.perfType ===
                    "Conservative" ? (
                      <div className="sum-inner-item">
                        {this.state.resultData.conservative !== undefined &&
                        this.state.resultData.conservative.validation_summary
                          .costSummaryText !== undefined &&
                        this.state.resultData.conservative.validation_summary
                          .costSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                title={
                                  this.state.resultData.conservative
                                    .validation_summary.costSummaryText
                                }
                                data={
                                  this.state.resultData.conservative
                                    .validation_summary.costSummaryDescription
                                }
                                affectString={
                                  this.state.resultData.conservative
                                    .validation_summary.perfAffected
                                }
                                valResult={
                                  this.state.resultData.conservative
                                    .validation_summary.validation_cost_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Conservative" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}

                        {this.state.resultData.conservative !== undefined &&
                        this.state.resultData.conservative.validation_summary
                          .perfSummaryText !== undefined &&
                        this.state.resultData.conservative.validation_summary
                          .perfSummaryText !== null ? (
                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad">
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.conservative
                                    .validation_summary.perfSummaryDescription
                                }
                                title={
                                  this.state.resultData.conservative
                                    .validation_summary.perfSummaryText
                                }
                                affectString={
                                  this.state.resultData.conservative
                                    .validation_summary.increasedCost
                                }
                                valResult={
                                  this.state.resultData.conservative
                                    .validation_summary.validation_perf_result
                                }
                                renderIcon={
                                  this.state.resultData.validationData
                                    .perfType === "Conservative" &&
                                  this.state.resultData.bvmState !==
                                    "VALIDATING"
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </Row>
                        ) : null}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {isResizingDone === true ? (
              <div className="Sub-Heading">{resizingHeading}</div>
            ) : null}
            {isResizingDone === true ? (
              <div
                className="sum-cont"
                id={`resizingRecommendation${this.state.analysisCnt}`}
              >
                <div
                  className="sum-item"
                  id={
                    this.state.resultData.aggressive !== undefined
                      ? this.state.resultData.aggressive
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.aggressive !== undefined ? (
                    this.state.resultData.aggressive
                      .isRecommendationSelected === true ? (
                      <div className="sum-inner-item">
                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.aggressive}
                            bvmState={this.state.resultData.bvmState}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className="sum-item"
                  id={
                    this.state.resultData.balanced !== undefined
                      ? this.state.resultData.balanced
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.balanced !== undefined ? (
                    this.state.resultData.balanced.isRecommendationSelected ===
                    true ? (
                      <div className="sum-inner-item">
                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.balanced}
                            bvmState={this.state.resultData.bvmState}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className="sum-item"
                  id={
                    this.state.resultData.conservative !== undefined
                      ? this.state.resultData.conservative
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.conservative !== undefined ? (
                    this.state.resultData.conservative
                      .isRecommendationSelected === true ? (
                      <div className="sum-inner-item">
                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.conservative}
                            bvmState={this.state.resultData.bvmState}
                            isAsp={this.state.isAsp}
                            entityType={this.state.entityType}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : null}
          </>
        </div>

        {/* done */}
        {/* Economical */}

        <div style={{ width: "60%", margin: "auto" }} id="allData">
          <div id={economicalId}>
            <div id="constHeading" style={{ textAlign: "center" }}>
              <b>
                <h3>
                  Economical
                  <label style={{ fontWeight: "300", fontSize: "14px" }}>
                    (P90)
                  </label>{" "}
                  Optimization Objective
                </h3>
              </b>
              <p>
                <i>Cost Reducing</i>{" "}
              </p>
            </div>
            <b>
              <h5>{analysisHeading}</h5>
            </b>
            {<br />}
            {<br />}
            <div id="pageEconomical">
              <Health
                typeID={`Economical${this.state.analysisCnt}`}
                data={this.state.resultData.aggressive}
                iconData={this.state.aggIconData}
                isResize={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                providerName={this.state.providerName}
              ></Health>
            </div>
            <div></div>
            <div>
              <div style={{ textAlign: "center" }}>
                {<br />}
                <b>
                  <h5>
                    {" "}
                    {recommendationHeadingLine1}
                    {<br />}for Economical Optimization Objective
                  </h5>
                </b>
              </div>
              {<br />}
              <div id="tabedata">
                {this.state.resultData.aggressive.vm.map((item, index) => (
                  <>
                    <Recommend
                      typeID={`Economical${this.state.analysisCnt}${
                        item?.recommendationChoiceNum || 0
                      }`}
                      data={this.state.resultData.aggressive}
                      iconData={this.state.aggIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                      type="recommendation"
                      tabID={item?.recommendationChoiceNum || 0}
                    >
                      {" "}
                    </Recommend>

                    <Row
                      id={`expectedBenefitsDrawbacksImgEconomical${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {this.state.resultData.aggressive?.summaryList &&
                          this.state.resultData.aggressive.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.costSummaryText !== undefined &&
                                filteredItem.costSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      justifyContent: "flex-start !important",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Cost Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.costSummaryText}
                                        data={
                                          filteredItem.costSummaryDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}

                        {this.state.resultData.aggressive?.summaryList &&
                          this.state.resultData.aggressive.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.perfSummaryText !== undefined &&
                                filteredItem.perfSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Performance Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.perfSummaryText}
                                        data={
                                          filteredItem.perfSummaryDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                      </div>
                    </Row>

                    <Row
                      id={`insightsandActionsImgEconomical${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {/* <div style={{ margin: "20px", marginTop: "30px" }}> */}

                        {item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                            >
                              <div
                                className="expected-cost-title-pdf"
                                style={{ marginTop: "8px" }}
                              >
                                AI Insights
                              </div>
                              <div
                                className="maindiv-text-summary-grad"
                                style={{
                                  marginTop: "0px",
                                  paddingTop: "0px",
                                  paddingRight: "5px",
                                }}
                              >
                                <ResingBenefitTextComponent
                                  title={item.gaiInsightSummary}
                                  affectString={item.gaiInsightDescription}
                                />
                              </div>
                            </div>
                          )}
                        {/* </div> */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            // gap: "10px",
                            width: "50%",
                          }}
                        >
                          <div
                            className="expected-cost-title-pdf"
                            style={{ marginTop: "8px" }}
                          >
                            Actions
                          </div>
                          <div className="maindiv-text-summary-grad">
                            <div
                              className="maindiv-text-summary maindiv-text-summary-grad"
                              style={{
                                marginTop: "0px",
                                paddingTop: "10px",
                              }}
                            >
                              <ul
                                style={{
                                  textAlign: "left",
                                  paddingRight: "5px",
                                }}
                              >
                                {item?.recommendationActions?.map(
                                  (action, index) => (
                                    <React.Fragment key={index}>
                                      <li key={index}>{action}</li>
                                    </React.Fragment>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </>
                ))}{" "}
              </div>
            </div>
            {/* Start Economical GAI Recommendation */}
            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Aggressive" ? (
              <>
                {" "}
                <div style={{ pageBreakAfter: "always" }}></div>
                <div style={{ pageBreakAfter: "always" }}>
                  <div>
                    {<br />}
                    <b>
                      <h5>
                        {" "}
                        GAI {recommendationHeadingLine1}
                        {<br />}for Economical Optimization Objective
                      </h5>
                    </b>
                  </div>
                  {<br />}
                  <div id="tabedata">
                    {" "}
                    <GaiRecommend
                      typeID={`Economical${this.state.analysisCnt}`}
                      data={this.state.resultData.gaiValidationData}
                      iconData={this.state.aggIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                    >
                      {" "}
                    </GaiRecommend>
                  </div>
                </div>
              </>
            ) : null}
            {/* End Economical GAI Recommendation */}

            {/* Start Economical Expected Benefits & Drawbacks GAI Recommendation */}

            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Aggressive" ? (
              <div>
                <div>
                  <b>
                    <h5>
                      GAI {expBenDrawHeadingLine1}
                      {<br />}for Economical Optimization Objective
                    </h5>
                  </b>
                </div>
                {<br />}
                <div id="tabedata">
                  <GaiResize
                    typeID={`Economical${this.state.analysisCnt}`}
                    data={this.state.resultData.gaiValidationData}
                    iconData={this.state.Aggressive}
                    isResize={false}
                    isAsp={this.state.isAsp}
                    entityType={this.state.entityType}
                  ></GaiResize>
                </div>
              </div>
            ) : null}
            {/* End Economical Expected Benefits & Drawbacks GAI Recommendation */}

            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Aggressive" ? (
              <div>
                <div>
                  <div style={{ marginLeft: "0px", marginRight: "10px" }}>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          {validationHeadingLine1}
                          {<br />}for Economical Optimization Objective
                        </h5>
                      </b>
                    </div>
                    {<br />}
                    <ValidationTable
                      typeID={`Economical${this.state.analysisCnt}`}
                      data={this.state.resultData.aggressive}
                      iconData={this.state.aggIconData}
                      valTableData={this.state.resultData.validationData}
                      isResize={true}
                      isLine={true}
                      isIcon={true}
                      valStatus={bvmStatus}
                      valObjective="Economical"
                    ></ValidationTable>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Aggressive" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div style={{ marginLeft: "0px", marginRight: "10px" }}>
                  <div id="constHeading" style={{ textAlign: "center" }}>
                    <b>
                      <h5>
                        {valBenDrawHeadingLine1}
                        {<br />}for Economical Optimization Objective
                      </h5>
                    </b>
                  </div>
                  <ValidationDetailsTable
                    typeID={`Economical${this.state.analysisCnt}`}
                    data={this.state.resultData.validationData}
                    isValidationGraphTable={false}
                    valSummary={
                      this.state.resultData.aggressive.validation_summary
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}
            {this.state.resultData.aggressive.isRecommendationSelected ===
            true ? (
              <div>
                <div id="tabedata">
                  <div id="constHeading" style={{ textAlign: "center" }}>
                    <b>
                      <h5>
                        {resizingHeadingLine1}
                        {<br />}for Economical Optimization Objective
                      </h5>
                    </b>
                  </div>
                  <Recommendstatus
                    typeID={`Economical${this.state.analysisCnt}`}
                    data={this.state.resultData.aggressive}
                    iconData={this.state.aggrIcondataStatus}
                    isResize={true}
                    isLine={true}
                    isIcon={true}
                    isAsp={this.state.isAsp}
                    entityType={this.state.entityType}
                    providerName={this.state.providerName}
                    type="recommendation"
                  ></Recommendstatus>
                </div>
              </div>
            ) : (
              ""
            )}
            <div>
              <div id="tabedata">
                <CostHealthModal
                  data={this.state.resultData.aggressive}
                  typeID={`Economical${this.state.analysisCnt}`}
                  type={"Economical"}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  providerName={this.state.providerName}
                />
              </div>
            </div>
            {/* done */}
            {/* start remaining */}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Aggressive" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Current {valSimPlotHeadingLine1}
                            {<br />} Economical Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            CPU Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_current_cpu_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_current_cpu_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            Memory Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_current_memory_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_current_memory_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Current {valSimPlotHeadingLine1}
                            {<br />} Economical Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Read Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_current_os_read_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_read_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Write Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk
                                .sim_current_os_write_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_write_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                {Object.keys(
                  this.state.resultData.validationData.validationDataDisks
                ).map((key, i) => {
                  return (
                    <div>
                      <Logo companiesDetails={this.props.companiesDetails} />
                      <div id="list_nav1">
                        <div
                          style={{ fontWeight: "600" }}
                          id={this.state.vmName}
                        >
                          {this.props.companiesDetails.CompanyName +
                            " " +
                            this.props.companiesDetails.ServiceName}
                        </div>
                        <div
                          style={{ width: "100%", textAlign: "center" }}
                          id="modalheader_lists"
                        >
                          {" "}
                          Validation Details of {this.state.vmName}{" "}
                          <div style={{ fontSize: "18px" }}>{platform}</div>
                        </div>
                      </div>
                      {vmOverviewInfoDiv}
                      {<br />}
                      <Row>
                        <Col>
                          <div
                            id="constHeading"
                            style={{ textAlign: "center" }}
                          >
                            <b>
                              <h5>
                                Current {valSimPlotHeadingLine1}
                                {<br />} Economical Optimization Objective
                              </h5>
                            </b>
                          </div>
                        </Col>
                      </Row>
                      <div className="container-verf container-verf-padding">
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "20px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Read Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_current_datadisk_read_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_read_graph
                              }
                            />
                          </Col>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "40px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Write Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_current_datadisk_write_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_write_graph
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Aggressive" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Recommended {valSimPlotHeadingLine1}
                            {<br />} Economical Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            CPU Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_rec_cpu_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_rec_cpu_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            Memory Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_rec_memory_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_rec_memory_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Recommended {valSimPlotHeadingLine1}
                            {<br />} Economical Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Read Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_rec_os_read_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_read_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Write Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_rec_os_write_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_write_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                {Object.keys(
                  this.state.resultData.validationData.validationDataDisks
                ).map((key, i) => {
                  return (
                    <div>
                      <Logo companiesDetails={this.props.companiesDetails} />
                      <div id="list_nav1">
                        <div
                          style={{ fontWeight: "600" }}
                          id={this.state.vmName}
                        >
                          {this.props.companiesDetails.CompanyName +
                            " " +
                            this.props.companiesDetails.ServiceName}
                        </div>
                        <div
                          style={{ width: "100%", textAlign: "center" }}
                          id="modalheader_lists"
                        >
                          {" "}
                          Validation Details of {this.state.vmName}{" "}
                          <div style={{ fontSize: "18px" }}>{platform}</div>
                        </div>
                      </div>
                      {vmOverviewInfoDiv}
                      {<br />}
                      <Row>
                        <Col>
                          <div
                            id="constHeading"
                            style={{ textAlign: "center" }}
                          >
                            <b>
                              <h5>
                                Recommended {valSimPlotHeadingLine1}
                                {<br />} Economical Optimization Objective
                              </h5>
                            </b>
                          </div>
                        </Col>
                      </Row>
                      <div className="container-verf container-verf-padding">
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "20px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Read Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_rec_datadisk_read_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_read_graph
                              }
                            />
                          </Col>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "40px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Write Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_rec_datadisk_write_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_write_graph
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </div>
        {/* end remaining */}

        {/* Balanced */}

        <div style={{ width: "60%", margin: "auto" }} id="allData">
          <div id={balancedId}>
            <div id="constHeading" style={{ textAlign: "center" }}>
              <b>
                <h3>
                  Balanced
                  <label style={{ fontWeight: "300", fontSize: "14px" }}>
                    (P95)
                  </label>{" "}
                  Optimization Objective
                </h3>
              </b>
              <p>
                <i>Cost Reducing & Performance Improving</i>{" "}
              </p>
            </div>
            <b>
              <h5>{analysisHeading}</h5>
            </b>
            {<br />}
            {<br />}
            <div id="tabedata">
              {" "}
              <Health
                typeID={`Balanced${this.state.analysisCnt}`}
                data={this.state.resultData.balanced}
                iconData={this.state.balIconData}
                isResize={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                providerName={this.state.providerName}
              ></Health>
            </div>
            <div></div>
            <div>
              <b>
                <h5>
                  {recommendationHeadingLine1}
                  {<br />}for Balanced Optimization Objective
                </h5>
              </b>
              {<br />}
              <div id="tabedata">
                {" "}
                {/* <Recommend
                  typeID={`Balanced${this.state.analysisCnt}`}
                  data={this.state.resultData.balanced}
                  iconData={this.state.balIconData}
                  isResize={true}
                  isLine={true}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  providerName={this.state.providerName}
                  type="recommendation"
                >
                  {" "}
                  
                </Recommend> */}
                {this.state.resultData.balanced.vm.map((item, index) => (
                  <>
                    <Recommend
                      typeID={`Balanced${this.state.analysisCnt}${
                        item?.recommendationChoiceNum || 0
                      }`}
                      data={this.state.resultData.balanced}
                      iconData={this.state.balIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                      type="recommendation"
                      tabID={item?.recommendationChoiceNum || 0}
                    >
                      {" "}
                    </Recommend>

                    <Row
                      id={`expectedBenefitsDrawbacksImgBalanced${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {this.state.resultData.balanced?.summaryList &&
                          this.state.resultData.balanced.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.costSummaryText !== undefined &&
                                filteredItem.costSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Cost Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.costSummaryText}
                                        data={
                                          filteredItem.costSummaryDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}

                        {this.state.resultData.balanced?.summaryList &&
                          this.state.resultData.balanced.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.perfSummaryText !== undefined &&
                                filteredItem.perfSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Performance Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.perfSummaryText}
                                        data={
                                          filteredItem.perfSummaryDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                      </div>

                      {/* <div style={{ margin: "20px", marginTop: "30px" }}>
                        {this.state.resultData.balanced?.vm &&
                          this.state.resultData.balanced.vm
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.gaiInsightSummary !== undefined &&
                                filteredItem.gaiInsightSummary !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      AI Insights
                                    </div>
                                    <div
                                      className="maindiv-text-summary maindiv-text-summary-grad"
                                      style={{
                                        marginTop: "0px",
                                        paddingTop: "0px",
                                      }}
                                    >
                                      <ResingBenefitTextComponent
                                        title={filteredItem.gaiInsightSummary}
                                        affectString={
                                          filteredItem.gaiInsightDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                      </div> */}
                    </Row>

                    <Row
                      id={`insightsandActionsImgBalanced${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {/* <div style={{ margin: "20px", marginTop: "30px" }}> */}

                        {item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                            >
                              <div
                                className="expected-cost-title-pdf"
                                style={{ marginTop: "8px" }}
                              >
                                AI Insights
                              </div>
                              <div
                                className="maindiv-text-summary maindiv-text-summary-grad"
                                style={{
                                  marginTop: "0px",
                                  paddingTop: "0px",
                                  paddingRight: "5px",
                                }}
                              >
                                <ResingBenefitTextComponent
                                  title={item.gaiInsightSummary}
                                  affectString={item.gaiInsightDescription}
                                />
                              </div>
                            </div>
                          )}

                        {/* </div> */}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            // gap: "10px",
                            width: "50%",
                          }}
                        >
                          <div
                            className="expected-cost-title-pdf"
                            style={{ marginTop: "8px" }}
                          >
                            Actions
                          </div>
                          <div className="maindiv-text-summary-grad">
                            <div
                              className="maindiv-text-summary maindiv-text-summary-grad"
                              style={{
                                marginTop: "0px",
                                paddingTop: "10px",
                              }}
                            >
                              <ul
                                style={{
                                  textAlign: "left",
                                  paddingRight: "5px",
                                }}
                              >
                                {item?.recommendationActions?.map(
                                  (action, index) => (
                                    <React.Fragment key={index}>
                                      <li key={index}>{action}</li>
                                    </React.Fragment>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </>
                ))}
              </div>
            </div>

            {/* Start Economical GAI Recommendation */}
            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Balanced" ? (
              <>
                {" "}
                <div>
                  <div>
                    {<br />}
                    <b>
                      <h5>
                        {" "}
                        GAI {recommendationHeadingLine1}
                        {<br />}for Balanced Optimization Objective
                      </h5>
                    </b>
                  </div>
                  {<br />}
                  <div id="tabedata">
                    {" "}
                    <GaiRecommend
                      typeID={`Balanced${this.state.analysisCnt}`}
                      data={this.state.resultData.gaiValidationData}
                      iconData={this.state.balIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                    >
                      {" "}
                    </GaiRecommend>
                  </div>
                </div>
              </>
            ) : null}

            {/* End Economical GAI Recommendation */}

            <div>
              <b>
                <h5>
                  {expBenDrawHeadingLine1}
                  {<br />}for Balanced Optimization Objective
                </h5>
              </b>
              {<br />}
              <div id="tabedata">
                {" "}
                <Resize
                  typeID={`Balanced${this.state.analysisCnt}`}
                  data={this.state.resultData.balanced}
                  iconData={this.state.Balanced}
                  isResize={false}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                ></Resize>
              </div>
            </div>

            {/* Start Balanced Expected Benefits & Drawbacks GAI Recommendation */}
            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Balanced" ? (
              <div>
                <div>
                  <b>
                    <h5>
                      GAI {expBenDrawHeadingLine1}
                      {<br />}for Balanced Optimization Objective
                    </h5>
                  </b>
                </div>
                {<br />}
                <div id="tabedata">
                  <GaiResize
                    typeID={`Balanced${this.state.analysisCnt}`}
                    data={this.state.resultData.gaiValidationData}
                    iconData={this.state.Balanced}
                    isResize={false}
                    isAsp={this.state.isAsp}
                    entityType={this.state.entityType}
                  ></GaiResize>
                </div>
              </div>
            ) : null}

            {/* End Economical Expected Benefits & Drawbacks GAI Recommendation */}

            {/* Start Gai Insight */}
            {/* {this.state.resultData &&
            this.state.resultData.balanced !== undefined &&
            Array.isArray(this.state.resultData.balanced.vm) &&
            this.state.resultData.balanced.vm[0].gaiInsightSummary !==
              undefined &&
            this.state.resultData.balanced.vm[0].gaiInsightSummary !== null ? (
              <>
                <div className="Sub-Heading">GAI Insight</div>

                <div
                  className="sum-cont"
                  id={`gaiInsightBalanced${this.state.analysisCnt}`}
                >
                  <div className="sum-item">
                    <div className="sum-inner-item">
                      {this.state.resultData.balanced !== undefined &&
                      Array.isArray(this.state.resultData.balanced.vm) &&
                      this.state.resultData.balanced.vm[0].gaiInsightSummary !==
                        undefined &&
                      this.state.resultData.balanced.vm[0].gaiInsightSummary !==
                        null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.balanced.vm[0]
                                  .gaiInsightSummary
                              }
                              affectString={
                                this.state.resultData.balanced
                                  .gaiInsightDescription
                              }
                            />
                          </div>
                        </Row>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            ) : null} */}
            {/* End Gai Insight */}

            {/*  Start remaining */}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Balanced" ? (
              <div>
                <div>
                  <div style={{ marginLeft: "0px", marginRight: "10px" }}>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          {validationHeadingLine1}
                          {<br />}for Balanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                    {<br />}
                    <ValidationTable
                      typeID={`Balanced${this.state.analysisCnt}`}
                      data={this.state.resultData.balanced}
                      iconData={this.state.balIcondataStatus}
                      valTableData={this.state.resultData.validationData}
                      isResize={true}
                      isLine={true}
                      isIcon={true}
                      valStatus={bvmStatus}
                      valObjective="Balanced"
                    ></ValidationTable>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Balanced" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div id="tabedata">
                  <div id="constHeading" style={{ textAlign: "center" }}>
                    <b>
                      <h5>
                        {valBenDrawHeadingLine1}
                        {<br />}for Balanced Optimization Objective
                      </h5>
                    </b>
                  </div>
                  <ValidationDetailsTable
                    typeID={`Balanced${this.state.analysisCnt}`}
                    data={this.state.resultData.validationData}
                    isValidationGraphTable={false}
                    valSummary={
                      this.state.resultData.balanced.validation_summary
                    }
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            <div>
              {this.state.resultData.balanced.isRecommendationSelected ===
              true ? (
                <div>
                  <div id="tabedata">
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          {resizingHeadingLine1}
                          {<br />}for Balanced ptimization Objective
                        </h5>
                      </b>
                    </div>
                    <Recommendstatus
                      typeID={`Balanced${this.state.analysisCnt}`}
                      data={this.state.resultData.balanced}
                      iconData={this.state.balIcondataStatus}
                      isResize={true}
                      isLine={true}
                      isIcon={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                      type="recommendation"
                    ></Recommendstatus>
                  </div>{" "}
                </div>
              ) : (
                ""
              )}
            </div>
            {/*  end remaining */}

            <div>
              <div id="tabedata">
                {" "}
                <CostHealthModal
                  data={this.state.resultData.balanced}
                  typeID={`Balanced${this.state.analysisCnt}`}
                  type={"Balanced"}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  providerName={this.state.providerName}
                />
              </div>
            </div>

            {/*  Start remaining */}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Balanced" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Current {valSimPlotHeadingLine1}
                            {<br />} Balanced Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            CPU Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_current_cpu_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_current_cpu_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            Memory Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_current_memory_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_current_memory_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Current {valSimPlotHeadingLine1}
                            {<br />} Balanced Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Read Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_current_os_read_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_read_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Write Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk
                                .sim_current_os_write_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_write_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                {Object.keys(
                  this.state.resultData.validationData.validationDataDisks
                ).map((key, i) => {
                  return (
                    <div>
                      <Logo companiesDetails={this.props.companiesDetails} />
                      <div id="list_nav1">
                        <div
                          style={{ fontWeight: "600" }}
                          id={this.state.vmName}
                        >
                          {this.props.companiesDetails.CompanyName +
                            " " +
                            this.props.companiesDetails.ServiceName}
                        </div>
                        <div
                          style={{ width: "100%", textAlign: "center" }}
                          id="modalheader_lists"
                        >
                          {" "}
                          Validation Details of {this.state.vmName}{" "}
                          <div style={{ fontSize: "18px" }}>{platform}</div>
                        </div>
                      </div>
                      {vmOverviewInfoDiv}
                      {<br />}
                      <Row>
                        <Col>
                          <div
                            id="constHeading"
                            style={{ textAlign: "center" }}
                          >
                            <b>
                              <h5>
                                Current {valSimPlotHeadingLine1}
                                {<br />} Balanced Optimization Objective
                              </h5>
                            </b>
                          </div>
                        </Col>
                      </Row>
                      <div className="container-verf container-verf-padding">
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "20px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Read Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_current_datadisk_read_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_read_graph
                              }
                            />
                          </Col>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "40px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Write Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_current_datadisk_write_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_write_graph
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
            {forValidation === true &&
            this.state.resultData.validationData.perfType === "Balanced" &&
            this.state.resultData.validationData.validationVM !== undefined &&
            this.state.resultData.validationData.validationVM !== null ? (
              <div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Recommended {valSimPlotHeadingLine1}
                            {<br />} Balanced Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            CPU Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_rec_cpu_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_rec_cpu_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            Memory Confidence :{" "}
                            {
                              this.state.resultData.validationData.validationVM
                                .sim_rec_memory_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData.validationVM
                              .sim_rec_memory_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                <div>
                  <Logo companiesDetails={this.props.companiesDetails} />
                  <div id="list_nav1">
                    <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                      {this.props.companiesDetails.CompanyName +
                        " " +
                        this.props.companiesDetails.ServiceName}
                    </div>
                    <div
                      style={{ width: "100%", textAlign: "center" }}
                      id="modalheader_lists"
                    >
                      {" "}
                      Validation Details of {this.state.vmName}{" "}
                      <div style={{ fontSize: "18px" }}>{platform}</div>
                    </div>
                  </div>
                  {vmOverviewInfoDiv}
                  {<br />}
                  <Row>
                    <Col>
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            Recommended {valSimPlotHeadingLine1}
                            {<br />} Balanced Optimization Objective
                          </h5>
                        </b>
                      </div>
                    </Col>
                  </Row>
                  <div className="container-verf container-verf-padding">
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "20px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Read Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_rec_os_read_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_read_graph
                          }
                        />
                      </Col>
                    </Row>
                    <Row style={{ textAlign: "center" }}>
                      <Col
                        style={{
                          marginTop: "40px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <div style={{ fontSize: "18px" }}>
                          <b>
                            OS Disk Write Throughput Confidence :{" "}
                            {
                              this.state.resultData.validationData
                                .validationOSDisk.sim_rec_os_write_confidence
                            }
                          </b>
                        </div>
                        <img
                          src={
                            "data:image/png;base64," +
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_write_graph
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
                {Object.keys(
                  this.state.resultData.validationData.validationDataDisks
                ).map((key, i) => {
                  return (
                    <div>
                      <Logo companiesDetails={this.props.companiesDetails} />
                      <div id="list_nav1">
                        <div
                          style={{ fontWeight: "600" }}
                          id={this.state.vmName}
                        >
                          {this.props.companiesDetails.CompanyName +
                            " " +
                            this.props.companiesDetails.ServiceName}
                        </div>
                        <div
                          style={{ width: "100%", textAlign: "center" }}
                          id="modalheader_lists"
                        >
                          {" "}
                          Validation Details of {this.state.vmName}{" "}
                          <div style={{ fontSize: "18px" }}>{platform}</div>
                        </div>
                      </div>
                      {vmOverviewInfoDiv}
                      {<br />}
                      <Row>
                        <Col>
                          <div
                            id="constHeading"
                            style={{ textAlign: "center" }}
                          >
                            <b>
                              <h5>
                                Recommended {valSimPlotHeadingLine1}
                                {<br />} Balanced Optimization Objective
                              </h5>
                            </b>
                          </div>
                        </Col>
                      </Row>
                      <div className="container-verf container-verf-padding">
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "20px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Read Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_rec_datadisk_read_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_read_graph
                              }
                            />
                          </Col>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Col
                            style={{
                              marginTop: "40px",
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          >
                            <div style={{ fontSize: "18px" }}>
                              <b>
                                Data Disk {key} Write Throughput Confidence :{" "}
                                {
                                  this.state.resultData.validationData
                                    .validationDataDisks[key]
                                    .sim_rec_datadisk_write_confidence
                                }
                              </b>
                            </div>
                            <img
                              src={
                                "data:image/png;base64," +
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_write_graph
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>
        </div>
        {/*  end remaining */}
        {/*end  Balanced */}
        {/* Enhanced */}

        <div id="allData" style={{ width: "60%", margin: "auto" }}>
          <div id={conservativeId}>
            <div id="constHeading" style={{ textAlign: "center" }}>
              <b>
                <h3>
                  Enhanced
                  <label style={{ fontWeight: "300", fontSize: "14px" }}>
                    (P99.5)
                  </label>{" "}
                  Optimization Objective{" "}
                </h3>
              </b>
              <p>
                <i>Performance Improving</i>{" "}
              </p>
            </div>
            <b>
              <h5>{analysisHeading}</h5>
            </b>
            {<br />}
            {<br />}
            <div id="tabedata">
              {" "}
              <Health
                typeID={`Enhanced${this.state.analysisCnt}`}
                data={this.state.resultData.conservative}
                iconData={this.state.healthyIconData}
                isResize={false}
                isAsp={this.state.isAsp}
                entityType={this.state.entityType}
                providerName={this.state.providerName}
              ></Health>
            </div>
            <div>
              <b>
                <h5>
                  {recommendationHeadingLine1}
                  {<br />}for Enhanced Optimization Objective
                </h5>
              </b>
              {<br />}
              <div id="tabedata">
                {" "}
                {/* <Recommend
                  typeID={`Enhanced${this.state.analysisCnt}`}
                  data={this.state.resultData.conservative}
                  iconData={this.state.healthyIconData}
                  isResize={true}
                  isLine={true}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  providerName={this.state.providerName}
                  type="recommendation"
                >
                  {" "}
                </Recommend> */}
                {this.state.resultData.conservative.vm.map((item, index) => (
                  <>
                    <Recommend
                      typeID={`Enhanced${this.state.analysisCnt}${
                        item?.recommendationChoiceNum || 0
                      }`}
                      data={this.state.resultData.conservative}
                      iconData={this.state.healthyIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                      type="recommendation"
                      tabID={item?.recommendationChoiceNum || 0}
                    >
                      {" "}
                    </Recommend>

                    <Row
                      id={`expectedBenefitsDrawbacksImgEnhanced${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {this.state.resultData.conservative?.summaryList &&
                          this.state.resultData.conservative.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.costSummaryText !== undefined &&
                                filteredItem.costSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Cost Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.costSummaryText}
                                        data={
                                          filteredItem.costSummaryDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}

                        {this.state.resultData.conservative?.summaryList &&
                          this.state.resultData.conservative.summaryList
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.perfSummaryText !== undefined &&
                                filteredItem.perfSummaryText !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      // gap: "10px",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      Expected Performance Effect
                                    </div>
                                    <div className="maindiv-text-summary-grad">
                                      <ResingBenefitTextComponent
                                        title={filteredItem.perfSummaryText}
                                        data={[
                                          ...filteredItem.perfSummaryDescription,
                                        ]}
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                      </div>

                      {/* <div style={{ margin: "20px", marginTop: "30px" }}>
                        {this.state.resultData.conservative?.vm &&
                          this.state.resultData.conservative.vm
                            .filter(
                              (summaryItem) =>
                                summaryItem.recommendationChoiceNum ===
                                (item?.recommendationChoiceNum || 0)
                            )
                            .map(
                              (filteredItem, index) =>
                                filteredItem.gaiInsightSummary !== undefined &&
                                filteredItem.gaiInsightSummary !== null && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      className="expected-cost-title-pdf"
                                      style={{ marginTop: "8px" }}
                                    >
                                      AI Insights
                                    </div>
                                    <div
                                      className="maindiv-text-summary maindiv-text-summary-grad"
                                      style={{
                                        marginTop: "0px",
                                        paddingTop: "0px",
                                      }}
                                    >
                                      <ResingBenefitTextComponent
                                        title={filteredItem.gaiInsightSummary}
                                        affectString={
                                          filteredItem.gaiInsightDescription
                                        }
                                      />
                                    </div>
                                  </div>
                                )
                            )}
                      </div> */}
                    </Row>

                    <Row
                      id={`insightsandActionsImgEnhanced${
                        this.state.analysisCnt
                      }${item?.recommendationChoiceNum || 0}`}
                    >
                      <div
                        style={{
                          margin: "20px",
                          display: "flex",
                          flexDirection: "row",
                          width: "100%",
                          gap: "30px",
                        }}
                      >
                        {/* <div style={{ margin: "20px", marginTop: "30px" }}> */}

                        {item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "50%",
                              }}
                            >
                              <div
                                className="expected-cost-title-pdf"
                                style={{ marginTop: "8px" }}
                              >
                                AI Insights
                              </div>
                              <div
                                className="maindiv-text-summary maindiv-text-summary-grad"
                                style={{
                                  marginTop: "0px",
                                  paddingTop: "0px",
                                  paddingRight: "5px",
                                }}
                              >
                                <ResingBenefitTextComponent
                                  title={item.gaiInsightSummary}
                                  affectString={item.gaiInsightDescription}
                                />
                              </div>
                            </div>
                          )}

                        {/* </div> */}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            // gap: "10px",
                            width: "50%",
                          }}
                        >
                          <div
                            className="expected-cost-title-pdf"
                            style={{ marginTop: "8px" }}
                          >
                            Actions
                          </div>
                          <div className="maindiv-text-summary-grad">
                            <div
                              className="maindiv-text-summary maindiv-text-summary-grad"
                              style={{
                                marginTop: "0px",
                                paddingTop: "10px",
                              }}
                            >
                              <ul
                                style={{
                                  textAlign: "left",
                                  paddingRight: "5px",
                                }}
                              >
                                {item?.recommendationActions?.map(
                                  (action, index) => (
                                    <React.Fragment key={index}>
                                      <li key={index}>{action}</li>
                                    </React.Fragment>
                                  )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </>
                ))}
              </div>
            </div>

            {/* Start Economical GAI Recommendation */}
            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Conservative" ? (
              <>
                {" "}
                <div>
                  <div>
                    {<br />}
                    <b>
                      <h5>
                        {" "}
                        GAI {recommendationHeadingLine1}
                        {<br />}for Enhanced Optimization Objective
                      </h5>
                    </b>
                  </div>
                  {<br />}
                  <div id="tabedata">
                    {" "}
                    <GaiRecommend
                      typeID={`Enhanced${this.state.analysisCnt}`}
                      data={this.state.resultData.gaiValidationData}
                      iconData={this.state.healthyIconData}
                      isResize={true}
                      isLine={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                    >
                      {" "}
                    </GaiRecommend>
                  </div>
                </div>
              </>
            ) : null}

            {/* End Economical GAI Recommendation */}

            <div>
              <b>
                <h5>
                  {expBenDrawHeadingLine1}
                  {<br />}for Enhanced Optimization Objective
                </h5>
              </b>
              {<br />}
              <div id="tabedata">
                {" "}
                <Resize
                  typeID={`Enhanced${this.state.analysisCnt}`}
                  data={this.state.resultData.conservative}
                  iconData={this.state.healthyIconData}
                  isResize={false}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                ></Resize>
              </div>
            </div>

            {/* Start Conservative Expected Benefits & Drawbacks GAI Recommendation */}
            {this.state.resultData &&
            this.state.resultData.gaiValidationData &&
            this.state.resultData.gaiValidationData.validationPerfType ===
              "Conservative" ? (
              <div>
                <div>
                  <b>
                    <h5>
                      GAI {expBenDrawHeadingLine1}
                      {<br />}for Conservative Optimization Objective
                    </h5>
                  </b>
                </div>
                {<br />}
                <div id="tabedata">
                  <GaiResize
                    typeID={`Enhanced${this.state.analysisCnt}`}
                    data={this.state.resultData.gaiValidationData}
                    iconData={this.state.healthyIconData}
                    isResize={false}
                    isAsp={this.state.isAsp}
                    entityType={this.state.entityType}
                  ></GaiResize>
                </div>
              </div>
            ) : null}

            {/* End Economical Expected Benefits & Drawbacks GAI Recommendation */}

            {/* Start Gai Insight */}
            {this.state.resultData &&
            this.state.resultData.conservative !== undefined &&
            Array.isArray(this.state.resultData.conservative.vm) &&
            this.state.resultData.conservative.vm[0].gaiInsightSummary !==
              undefined &&
            this.state.resultData.conservative.vm[0].gaiInsightSummary !==
              null ? (
              <>
                <div className="Sub-Heading">GAI Insights</div>

                <div
                  className="sum-cont"
                  id={`gaiInsightEnhanced${this.state.analysisCnt}`}
                >
                  <div className="sum-item">
                    <div className="sum-inner-item">
                      {this.state.resultData.conservative !== undefined &&
                      Array.isArray(this.state.resultData.conservative.vm) &&
                      this.state.resultData.conservative.vm[0]
                        .gaiInsightSummary !== undefined &&
                      this.state.resultData.conservative.vm[0]
                        .gaiInsightSummary !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.conservative.vm[0]
                                  .gaiInsightSummary
                              }
                              affectString={
                                this.state.resultData.conservative.vm[0]
                                  .gaiInsightDescription
                              }
                            />
                          </div>
                        </Row>
                      ) : null}
                    </div>
                  </div>
                </div>
              </>
            ) : null}
            {/* End Gai Insight */}

            {/* start remaining*/}
            <div>
              {forValidation === true &&
              this.state.resultData.validationData.perfType ===
                "Conservative" ? (
                <div>
                  <div>
                    <div id="tabedata">
                      <div id="constHeading" style={{ textAlign: "center" }}>
                        <b>
                          <h5>
                            {validationHeadingLine1}
                            {<br />}for Enhanced Optimization Objective
                          </h5>
                        </b>
                      </div>
                      {<br />}
                      <ValidationTable
                        typeID={`Enhanced${this.state.analysisCnt}`}
                        data={this.state.resultData.conservative}
                        iconData={this.state.healthyIcondataStatus}
                        valTableData={this.state.resultData.validationData}
                        isResize={true}
                        isLine={true}
                        isIcon={true}
                        valStatus={bvmStatus}
                        valObjective="Enhanced"
                      ></ValidationTable>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {forValidation === true &&
              this.state.resultData.validationData.perfType ===
                "Conservative" &&
              this.state.resultData.validationData.validationVM !== undefined &&
              this.state.resultData.validationData.validationVM !== null ? (
                <div>
                  <div id="tabedata">
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          {valBenDrawHeadingLine1}
                          {<br />}for Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                    <ValidationDetailsTable
                      typeID={`Enhanced${this.state.analysisCnt}`}
                      data={this.state.resultData.validationData}
                      isValidationGraphTable={false}
                      valSummary={
                        this.state.resultData.conservative.validation_summary
                      }
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              {this.state.resultData.conservative.isRecommendationSelected ===
              true ? (
                <div>
                  <div id="tabedata">
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          {resizingHeadingLine1}
                          {<br />}for Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                    <Recommendstatus
                      typeID={`Enhanced${this.state.analysisCnt}`}
                      data={this.state.resultData.conservative}
                      iconData={this.state.healthyIcondataStatus}
                      isResize={true}
                      isLine={true}
                      isIcon={true}
                      isAsp={this.state.isAsp}
                      entityType={this.state.entityType}
                      providerName={this.state.providerName}
                      type="recommendation"
                    ></Recommendstatus>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>

            {/* end remaining*/}

            <div>
              <div id="tabedata">
                <CostHealthModal
                  data={this.state.resultData.conservative}
                  typeID={`Enhanced${this.state.analysisCnt}`}
                  type={"Enhanced"}
                  isAsp={this.state.isAsp}
                  entityType={this.state.entityType}
                  providerName={this.state.providerName}
                />
              </div>
            </div>
          </div>

          {/* start remaining*/}
          {forValidation === true &&
          this.state.resultData.validationData.perfType === "Conservative" &&
          this.state.resultData.validationData.validationVM !== undefined &&
          this.state.resultData.validationData.validationVM !== null ? (
            <div>
              <div>
                <Logo companiesDetails={this.props.companiesDetails} />
                <div id="list_nav1">
                  <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                    {this.props.companiesDetails.CompanyName +
                      " " +
                      this.props.companiesDetails.ServiceName}
                  </div>
                  <div
                    style={{ width: "100%", textAlign: "center" }}
                    id="modalheader_lists"
                  >
                    {" "}
                    Validation Details of {this.state.vmName}{" "}
                    <div style={{ fontSize: "18px" }}>{platform}</div>
                  </div>
                </div>
                {vmOverviewInfoDiv}
                {<br />}
                <Row>
                  <Col>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          Current {valSimPlotHeadingLine1}
                          {<br />} Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                  </Col>
                </Row>
                <div className="container-verf container-verf-padding">
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "20px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          CPU Confidence :{" "}
                          {
                            this.state.resultData.validationData.validationVM
                              .sim_current_cpu_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationVM
                            .sim_current_cpu_graph
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "40px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          Memory Confidence :{" "}
                          {
                            this.state.resultData.validationData.validationVM
                              .sim_current_memory_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationVM
                            .sim_current_memory_graph
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div>
                <Logo companiesDetails={this.props.companiesDetails} />
                <div id="list_nav1">
                  <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                    {this.props.companiesDetails.CompanyName +
                      " " +
                      this.props.companiesDetails.ServiceName}
                  </div>
                  <div
                    style={{ width: "100%", textAlign: "center" }}
                    id="modalheader_lists"
                  >
                    {" "}
                    Validation Details of {this.state.vmName}{" "}
                    <div style={{ fontSize: "18px" }}>{platform}</div>
                  </div>
                </div>
                {vmOverviewInfoDiv}
                {<br />}
                <Row>
                  <Col>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          Current {valSimPlotHeadingLine1}
                          {<br />} Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                  </Col>
                </Row>
                <div className="container-verf container-verf-padding">
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "20px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          OS Disk Read Throughput Confidence :{" "}
                          {
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_read_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationOSDisk
                            .sim_current_os_read_graph
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "40px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          OS Disk Write Throughput Confidence :{" "}
                          {
                            this.state.resultData.validationData
                              .validationOSDisk.sim_current_os_write_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationOSDisk
                            .sim_current_os_write_graph
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              {Object.keys(
                this.state.resultData.validationData.validationDataDisks
              ).map((key, i) => {
                return (
                  <div>
                    <Logo companiesDetails={this.props.companiesDetails} />
                    <div id="list_nav1">
                      <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                        {this.props.companiesDetails.CompanyName +
                          " " +
                          this.props.companiesDetails.ServiceName}
                      </div>
                      <div
                        style={{ width: "100%", textAlign: "center" }}
                        id="modalheader_lists"
                      >
                        {" "}
                        Validation Details of {this.state.vmName}{" "}
                        <div style={{ fontSize: "18px" }}>{platform}</div>
                      </div>
                    </div>
                    {vmOverviewInfoDiv}
                    {<br />}
                    <Row>
                      <Col>
                        <div id="constHeading" style={{ textAlign: "center" }}>
                          <b>
                            <h5>
                              Current {valSimPlotHeadingLine1}
                              {<br />} Enhanced Optimization Objective
                            </h5>
                          </b>
                        </div>
                      </Col>
                    </Row>
                    <div className="container-verf container-verf-padding">
                      <Row style={{ textAlign: "center" }}>
                        <Col
                          style={{
                            marginTop: "20px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>
                            <b>
                              Data Disk {key} Read Throughput Confidence :{" "}
                              {
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_read_confidence
                              }
                            </b>
                          </div>
                          <img
                            src={
                              "data:image/png;base64," +
                              this.state.resultData.validationData
                                .validationDataDisks[key]
                                .sim_current_datadisk_read_graph
                            }
                          />
                        </Col>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Col
                          style={{
                            marginTop: "40px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>
                            <b>
                              Data Disk {key} Write Throughput Confidence :{" "}
                              {
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_current_datadisk_write_confidence
                              }
                            </b>
                          </div>
                          <img
                            src={
                              "data:image/png;base64," +
                              this.state.resultData.validationData
                                .validationDataDisks[key]
                                .sim_current_datadisk_write_graph
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
          {forValidation === true &&
          this.state.resultData.validationData.perfType === "Conservative" &&
          this.state.resultData.validationData.validationVM !== undefined &&
          this.state.resultData.validationData.validationVM !== null ? (
            <div>
              <div>
                <Logo companiesDetails={this.props.companiesDetails} />
                <div id="list_nav1">
                  <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                    {this.props.companiesDetails.CompanyName +
                      " " +
                      this.props.companiesDetails.ServiceName}
                  </div>
                  <div
                    style={{ width: "100%", textAlign: "center" }}
                    id="modalheader_lists"
                  >
                    {" "}
                    Validation Details of {this.state.vmName}{" "}
                    <div style={{ fontSize: "18px" }}>{platform}</div>
                  </div>
                </div>
                {vmOverviewInfoDiv}
                {<br />}
                <Row>
                  <Col>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          Recommended {valSimPlotHeadingLine1}
                          {<br />}Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                  </Col>
                </Row>
                <div className="container-verf container-verf-padding">
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "20px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          CPU Confidence :{" "}
                          {
                            this.state.resultData.validationData.validationVM
                              .sim_rec_cpu_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationVM
                            .sim_rec_cpu_graph
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "40px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          Memory Confidence :{" "}
                          {
                            this.state.resultData.validationData.validationVM
                              .sim_rec_memory_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationVM
                            .sim_rec_memory_graph
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              <div>
                <Logo companiesDetails={this.props.companiesDetails} />
                <div id="list_nav1">
                  <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                    Serra Labs Console
                  </div>
                  <div
                    style={{ width: "100%", textAlign: "center" }}
                    id="modalheader_lists"
                  >
                    {" "}
                    Validation Details of {this.state.vmName}{" "}
                    <div style={{ fontSize: "18px" }}>{platform}</div>
                  </div>
                </div>
                {vmOverviewInfoDiv}
                {<br />}
                <Row>
                  <Col>
                    <div id="constHeading" style={{ textAlign: "center" }}>
                      <b>
                        <h5>
                          Recommended {valSimPlotHeadingLine1}
                          {<br />}Enhanced Optimization Objective
                        </h5>
                      </b>
                    </div>
                  </Col>
                </Row>
                <div className="container-verf container-verf-padding">
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "20px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          OS Disk Read Throughput Confidence :{" "}
                          {
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_read_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationOSDisk
                            .sim_rec_os_read_graph
                        }
                      />
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center" }}>
                    <Col
                      style={{
                        marginTop: "40px",
                        marginLeft: "auto",
                        marginRight: "auto",
                      }}
                    >
                      <div style={{ fontSize: "18px" }}>
                        <b>
                          OS Disk Write Throughput Confidence :{" "}
                          {
                            this.state.resultData.validationData
                              .validationOSDisk.sim_rec_os_write_confidence
                          }
                        </b>
                      </div>
                      <img
                        src={
                          "data:image/png;base64," +
                          this.state.resultData.validationData.validationOSDisk
                            .sim_rec_os_write_graph
                        }
                      />
                    </Col>
                  </Row>
                </div>
              </div>
              {Object.keys(
                this.state.resultData.validationData.validationDataDisks
              ).map((key, i) => {
                return (
                  <div>
                    <Logo companiesDetails={this.props.companiesDetails} />
                    <div id="list_nav1">
                      <div style={{ fontWeight: "600" }} id={this.state.vmName}>
                        {this.props.companiesDetails.CompanyName +
                          " " +
                          this.props.companiesDetails.ServiceName}
                      </div>
                      <div
                        style={{ width: "100%", textAlign: "center" }}
                        id="modalheader_lists"
                      >
                        {" "}
                        Validation Details of {this.state.vmName}{" "}
                        <div style={{ fontSize: "18px" }}>{platform}</div>
                      </div>
                    </div>
                    {vmOverviewInfoDiv}
                    {<br />}
                    <Row>
                      <Col>
                        <div id="constHeading" style={{ textAlign: "center" }}>
                          <b>
                            <h5>
                              Recommended {valSimPlotHeadingLine1}
                              {<br />} Enhanced Optimization Objective
                            </h5>
                          </b>
                        </div>
                      </Col>
                    </Row>
                    <div className="container-verf container-verf-padding">
                      <Row style={{ textAlign: "center" }}>
                        <Col
                          style={{
                            marginTop: "20px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>
                            <b>
                              Data Disk {key} Read Throughput Confidence :{" "}
                              {
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_read_confidence
                              }
                            </b>
                          </div>
                          <img
                            src={
                              "data:image/png;base64," +
                              this.state.resultData.validationData
                                .validationDataDisks[key]
                                .sim_rec_datadisk_read_graph
                            }
                          />
                        </Col>
                      </Row>
                      <Row style={{ textAlign: "center" }}>
                        <Col
                          style={{
                            marginTop: "40px",
                            marginLeft: "auto",
                            marginRight: "auto",
                          }}
                        >
                          <div style={{ fontSize: "18px" }}>
                            <b>
                              Data Disk {key} Write Throughput Confidence :{" "}
                              {
                                this.state.resultData.validationData
                                  .validationDataDisks[key]
                                  .sim_rec_datadisk_write_confidence
                              }
                            </b>
                          </div>
                          <img
                            src={
                              "data:image/png;base64," +
                              this.state.resultData.validationData
                                .validationDataDisks[key]
                                .sim_rec_datadisk_write_graph
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>

        {/* end remaining*/}

        {/*end  Enhanced */}
      </div>
    );
  }
}

export default EntityTypeSummary;
